export const environment = {
	production: true,
	apiUrl: 'API_DEFAULT_URL',
	imageUrl: 'IMAGE_DEFAULT_URL',
	maestroUrl: 'https://register.zvendo.com/api/v4/',
	languageBaseUrl: 'https://register.zvendo.com/translations/',
	defaultImage: 'https://register.zvendo.com/images/store-empty-product-category.jpeg',
	localStore: 'n5.zvendo.dev'
};